document.addEventListener("DOMContentLoaded", function () {
  // --- ELEMENTS ---
  const areaInput = document.getElementById("area_input");
  const wastageCheckbox = document.getElementById("toggle_wastage");
  const wastageValue = document.getElementById("wastage_value");
 
  const qtyInput = document.getElementById("qty_input");
  const qtyMinus = document.getElementById("qty_minus");
  const qtyPlus = document.getElementById("qty_plus");
 
  const coverageEl = document.getElementById("coverage");
  const totalPriceEl = document.getElementById("total_price");
  const comparePriceEl = document.getElementById("compare_price");
  const cartQtyInput = document.getElementById("flooring-quantity");
 
  // This calculator isn't rendered on every product template
  if (!window.FLOORING_DATA || !areaInput || !wastageCheckbox || !qtyInput || !qtyMinus || !qtyPlus || !coverageEl || !totalPriceEl || !cartQtyInput) {
    return;
  }

  // --- DATA FROM LIQUID ---
  const { packSize, packPriceDiscounted, packPriceCompare, floorStyle, deliveryDate } = window.FLOORING_DATA;
 
  // --- WASTAGE ---
  function getWastagePercent() {
    return floorStyle === "Herringbone" || floorStyle === "Chevron" ? 0.15 : 0.10;
  }
 
  // --- ROUND HELPER ---
  function round2(num) {
    return Math.round(num * 100) / 100;
  }
 
  // Last whole-pack quantity the customer committed. Restored if they
  // leave the pack field blank or invalid.
  let lastValidQty = 1;

  function renderQuote(packs, area) {
    const includeWastage = wastageCheckbox.checked;
    const wastagePercent = getWastagePercent();
    const wastage = includeWastage ? round2(area * wastagePercent) : 0;
    const coverage = round2(packs * round2(packSize));
    const total = round2(packs * round2(packPriceDiscounted / 100));

    if (comparePriceEl && packPriceCompare > packPriceDiscounted) {
      const totalCompare = round2(packs * round2(packPriceCompare / 100));
      comparePriceEl.textContent = "£" + totalCompare.toFixed(2);
      comparePriceEl.style.display = "";
    } else if (comparePriceEl) {
      comparePriceEl.style.display = "none";
    }

    coverageEl.textContent = coverage.toFixed(2) + "m²";
    wastageValue.textContent = wastage.toFixed(2) + "m²";
    totalPriceEl.textContent = "£" + total.toFixed(2);

    const packText = String(packs);
    if (qtyInput.value !== packText) qtyInput.value = packText;
    cartQtyInput.value = packText;
    lastValidQty = packs;
    qtyMinus.disabled = packs <= 1;

    // Area is written without an input event when packs change. Accessories
    // listen for this and recalculate rolls/tubs from the updated area.
    document.dispatchEvent(new CustomEvent("flooring:quantity-change"));
  }

  // Whole packs needed for a measured area. Cutting waste is included only
  // when the customer asks for it. Accessories use the measured area itself.
  function packsForArea(area) {
    const includeWastage = wastageCheckbox.checked;
    const wastagePercent = getWastagePercent();
    const wastage = includeWastage ? round2(area * wastagePercent) : 0;
    const adjustedArea = round2(area + wastage);

    let packsNeeded = Math.ceil(round2(adjustedArea / round2(packSize)));
    if (!Number.isFinite(packsNeeded) || packsNeeded < 0) packsNeeded = 0;
    if (area > 0 && packsNeeded < 1) packsNeeded = 1;
    return packsNeeded;
  }

  function calculateFromArea() {
    const area = round2(parseFloat(areaInput.value) || 0);
    renderQuote(packsForArea(area), area);
  }

  // Net m² those packs will cover, shown to 2 decimals. The value is chosen
  // so measuring that area recommends the same pack count again.
  function areaForPackQuantity(qty) {
    const includeWastage = wastageCheckbox.checked;
    const wastagePercent = getWastagePercent();
    const coverage = round2(qty * round2(packSize));
    if (!includeWastage) return coverage;

    const seed = round2(coverage / (1 + wastagePercent));
    if (packsForArea(seed) === qty) return seed;

    for (let step = 1; step <= 50; step++) {
      const down = round2(seed - step * 0.01);
      if (down > 0 && packsForArea(down) === qty) return down;
      const up = round2(seed + step * 0.01);
      if (packsForArea(up) === qty) return up;
    }

    return seed;
  }

  function updateFromQuantity(newQty) {
    const qty = parseInt(newQty, 10);
    if (!qty || qty < 1) return;

    const areaFromPacks = areaForPackQuantity(qty);
    areaInput.value = areaFromPacks.toFixed(2);
    renderQuote(qty, areaFromPacks);
  }

  function readTypedPackQty() {
    const text = String(qtyInput.value).trim();
    if (!/^\d+$/.test(text)) return null;
    const qty = parseInt(text, 10);
    return qty >= 1 ? qty : null;
  }

  // --- EVENT LISTENERS ---
  areaInput.addEventListener("input", () => calculateFromArea());
  wastageCheckbox.addEventListener("change", () => calculateFromArea());

  qtyPlus.addEventListener("click", () => {
    const qty = readTypedPackQty() || lastValidQty;
    updateFromQuantity(qty + 1);
  });

  qtyMinus.addEventListener("click", () => {
    const qty = readTypedPackQty() || lastValidQty;
    updateFromQuantity(qty - 1);
  });

  qtyInput.addEventListener("input", () => {
    const qty = readTypedPackQty();
    if (qty) updateFromQuantity(qty);
  });

  qtyInput.addEventListener("blur", () => {
    const raw = String(qtyInput.value).trim();
    if (raw === "") {
      qtyInput.value = String(lastValidQty);
      return;
    }
    const qty = Math.round(Number(raw));
    if (!Number.isFinite(qty) || qty < 1) {
      qtyInput.value = String(lastValidQty);
      return;
    }
    updateFromQuantity(qty);
  });

  qtyInput.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      qtyInput.blur();
    }
    if (event.key === "." || event.key === "e" || event.key === "E" || event.key === "+" || event.key === "-") {
      event.preventDefault();
    }
  });

  qtyInput.addEventListener("focus", () => {
    requestAnimationFrame(() => qtyInput.select());
  });

  qtyInput.addEventListener("wheel", (event) => {
    event.preventDefault();
  }, { passive: false });
 
  // --- INITIALIZE ---
  areaInput.value = "1.00";
  wastageCheckbox.checked = false;
  calculateFromArea();
 
  function addBusinessDays(date, days) {
    const result = new Date(date);
 
    while (days > 0) {
      result.setDate(result.getDate() + 1);
 
      const day = result.getDay();
      if (day !== 0 && day !== 6) {
        days--;
      }
    }
 
    return result;
  }
 
  // --- RECALCULATE ON CART DRAWER OPEN / SECTION LOAD ---
  document.addEventListener("shopify:section:load", () => calculateFromArea());
  const cartDrawer = document.getElementById("cart-drawer");
  if (cartDrawer) {
    cartDrawer.addEventListener("drawer:open", () => calculateFromArea());
  }
 
  // --- DELIVERY DATE LOGIC ---
  const MONTH_NAMES = [
    "january", "february", "march", "april", "may", "june",
    "july", "august", "september", "october", "november", "december"
  ];
 
  // Parses formats like "30September2026" or "3September2026" (day + full month name + year,
  // no separators). new Date() is deliberately NOT used here: Safari's strict parser returns
  // Invalid Date for this non-standard format even though Chrome's lenient parser accepts it.
  function parseNoSeparatorDate(str) {
    const match = str.match(/^(\d{1,2})([A-Za-z]+)(\d{4})$/);
    if (!match) return new Date(NaN);
 
    const [, dayStr, monthStr, yearStr] = match;
    const monthIndex = MONTH_NAMES.indexOf(monthStr.toLowerCase());
    if (monthIndex === -1) return new Date(NaN);
 
    return new Date(Number(yearStr), monthIndex, Number(dayStr));
  }
 
  function updateDeliveryDate(element, deliveryDate) {
    if (!element || !deliveryDate) return;
 
    let displayDate = '';
    const now = new Date();
 
    const unavailableDates = [
      '2026-04-03',
      '2026-04-05',
      '2026-04-06',
      '2026-04-07',
      '2026-04-08',
    ];
 
    const toDateKey = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
 
    if (deliveryDate.startsWith('Lead:')) {
      const leadTime = parseInt(deliveryDate.split('Lead:')[1].trim(), 10);
      if (!isNaN(leadTime)) {
        let leadDate = addBusinessDays(now, leadTime);
 
        while (unavailableDates.includes(toDateKey(leadDate))) {
          leadDate = addBusinessDays(leadDate, 1);
        }
 
        displayDate = leadDate.toLocaleDateString(undefined, {
          weekday: 'long',
          day: 'numeric',
          month: 'long'
        });
      }
 
    } else if (deliveryDate.startsWith('Delay:')) {
      const datePart = deliveryDate.split('Delay:')[1].trim();
 
      // Fixed: was `new Date(datePart)`, which Safari fails to parse for the
      // no-separator "30September2026" format used in the metafield.
      let parsedDate = parseNoSeparatorDate(datePart);
 
      if (!isNaN(parsedDate.getTime())) {
        while (unavailableDates.includes(toDateKey(parsedDate))) {
          parsedDate = addBusinessDays(parsedDate, 1);
        }
 
        displayDate = parsedDate.toLocaleDateString(undefined, {
          weekday: 'long',
          day: 'numeric',
          month: 'long'
        });
      } else {
        console.warn('Could not parse delivery date:', datePart);
      }
 
    } else if (deliveryDate === 'NextDay') {
      const daysToAdd = now.getHours() < 12 ? 1 : 2;
      let nextDate = addBusinessDays(now, daysToAdd);
 
      while (unavailableDates.includes(toDateKey(nextDate))) {
        nextDate = addBusinessDays(nextDate, 1);
      }
 
      displayDate = nextDate.toLocaleDateString(undefined, {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      });
    }
 
    if (displayDate) {
      element.innerHTML = `Delivery available from <strong>${displayDate}</strong> or free storage for 4 months`;
    }
  }
 
  const deliveryElement = document.getElementById("delivery-date");
  updateDeliveryDate(deliveryElement, deliveryDate);
});